import { c as _c } from "react/compiler-runtime";
import Grid from '@mui/material/Grid';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
export default function ReviewVideo() {
  const $ = _c(3);
  const {
    videoDocument
  } = useReviewContext();
  if (!videoDocument) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mt: 3.5
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== videoDocument) {
    t1 = <Grid sx={t0} size={12}><StructuredContentRenderer doc={videoDocument} /></Grid>;
    $[1] = videoDocument;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}